<template>
  <div class="renderPage">
    <v-toolbar color="primary" dark elevation="1" class="mb-1 mb-md-2 mb-lg-2">
      <v-spacer />
      <v-toolbar-title class="text-capitalize">
        Listado de Clientes
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon color="white" to="/home">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-data-table :headers="headers" :items="items" :search="search">
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <v-text-field
            class="text-xs-center"
            v-model="search"
            append-icon="mdi-feature-search-outline"
            label="Búsqueda"
            single-line
            hide-details
            dense
          >
          </v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" >
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                Nuevo
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-form ref="form" v-model="valid">
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="4" sm="6">
                        <v-text-field
                          v-model="editedItem.dni"
                          label="Cédula"
                          :rules="nameRules"
                          required
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="8" sm="6">
                        <v-text-field
                          v-model="editedItem.name"
                          label="Nombre"
                          :rules="nameRules"
                          required
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4" sm="4">
                        <v-text-field
                          v-model="editedItem.phone"
                          label="Teléfono"
                          :rules="nameRules"
                          required
                        ></v-text-field>
                      </v-col>
                      
                      <v-col cols="12" md="4" sm="4">
                        <v-text-field
                          v-model="editedItem.cellPhone"
                          label="Celular"
                          :rules="nameRules"
                          required
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4" sm="4">
                        <v-text-field
                          v-model="editedItem.email"
                          label="Correo"
                          :rules="nameRules"
                          required
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4" sm="4">
                        <v-text-field
                          v-model="editedItem.profession"
                          label="Profesión"
                          :rules="nameRules"
                          required
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4" sm="4">
                        <v-text-field
                          v-model="editedItem.salary"
                          label="Salario"
                          :rules="nameRules"
                          required
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4" sm="4">
                        <v-text-field
                          v-model="editedItem.maritalStatus"
                          label="Estado Civil"
                          :rules="nameRules"
                          required
                        ></v-text-field>
                      </v-col>

                      <v-col col="12" md="4" sm="6">
                        <v-select
                          label="Proposito"
                          item-text="name"
                          item-value="bonusTypeId"
                          v-model="editedItem.bonusType"
                          :items="bonusTypes"></v-select>
                      </v-col>

                      <v-col cols="12" md="8" sm="6">
                        <v-text-field
                          v-model="editedItem.address"
                          label="Dirección"
                          :rules="nameRules"
                          required
                        ></v-text-field>
                      </v-col>
                      
                    </v-row>
                  </v-container>
                  
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close()">
                      Cancelar
                    </v-btn>
                    <v-btn
                      :disabled="!valid"
                      color="blue darken-1"
                      text
                      @click="save()"
                    >
                      Guardar
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.type`]="{ item }">
        <v-simple-checkbox
          v-model="item.type"
          disabled>

        </v-simple-checkbox>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getData()"> Refrescar </v-btn>
      </template>
    </v-data-table>
    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue"/>
  </div>
</template>

<script>
import axios from "axios";
import Snackbar from './shared/Snackbar.vue';

export default {
  components: {
    Snackbar
  },
  data() {
    return {
      dialog: false,
      valid: false,
      search: "",
      snackText: "",
      snackValue: false,
      headers: [
        {
          text: "Cédula",
          align: "start",
          value: "dni",
          width: 100
        },
        {
          text: "Nombre",
          align: "start",
          value: "name",
        },
        {
          text: "Teléfono",
          align: "start",
          value: "phone",
          width: 150
        },
        {
          text: "Celular",
          align: "start",
          value: "cellPhone",
          width: 150
        },
        { text: "Acciones", value: "actions", width: 100, sortable: false },
      ],
      items: [],
      bonusTypes: [],
      editedIndex: -1,
      editedItem: {
        dni: "",
        name: "",
        profession: "",
        phone: "",
        cellPhone: "",
        salary: "",
        address: "",
        bonusType: 0,
        bonusName: "",
        maritalStatus: "",
        userId:	0,
        email: ""
      },
      defaultItem: {
        dni: "",
        name: "",
        phone: "",
        cellPhone: "",
        email: "",
        profession: "",
        salary: "",
        address: "",
        bonusType: 0,
        maritalStatus: "",
        userId:	0
      },
      nameRules: [
        v => !!v || 'Campo requerido',
        v => v.length <= 300 || 'El nombre del caracter debe de tener menos de 300 caracteres',
      ],
      passwordRules: [
        v => !!v || 'Campo requerido',
        v => v.length <= 20 || 'La contraseña debe de tener menos de 20 caracteres',
      ]
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Cliente" : "Editar Cliente"
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },

    search() {
      this.snackValue = false
    }
  },

  created() {
    this.getData()
    this.getBonus()
  },

  methods: {
    getData() {
      let me = this;
      axios
        .get("/api/Client/getClientAll?hasCase=false")
        .then(function (response) {
          me.items = response.data;
        })
        .catch(function (error) {
          console.log(error)
        });
    },

    getBonus() {
      let me = this;
      axios
        .get("/api/Configuration/getBonusTypeAll")
        .then(function (response) {
          me.bonusTypes = response.data;
        })
        .catch(function (error) {
          console.log(error)
        });
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    save() {
      let me = this

      if (this.editedIndex > -1) {
        axios
          .post("/api/Client/updateClient", this.editedItem)
          .then(function() {
            me.snackText = "Registro modificado satisfactoriamente"
            me.snackValue = true
            me.getData()
          })
          .catch(function(error) {
            console.log(error)
            // me.saved(false);
          });
      } else {
        axios
          .post("/api/Client/insertClient", this.editedItem)
          .then(function() {
            me.snackText = "Registro agregado satisfactoriamente"
            me.snackValue = true
            me.getData()
          })
          .catch(function(error) {
            console.log(error)
            // me.saved(false);
          });
      }
      this.close()
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedIndex = -1
        this.editedItem = Object.assign({}, this.defaultItem)
        this.$refs.form.resetValidation()
      });
    },
  },
};
</script>